export default {"src":"/_next/static/media/more2.4d05f967.svg","height":16,"width":4};